






import { Component, Prop, Vue } from 'vue-property-decorator';
import { ImageLinkDto, LinkDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';

@Component({
  components: {
    CmsLink,
  },
})
export default class CmsImageLink extends Vue {
  @Prop({required: true})
  public readonly model!: ImageLinkDto;

  @Prop({required: false, default: false})
  public readonly omitIfNoCaption: boolean = false;

  public get link(): LinkDto {
    return {
      caption: this.model.caption,
      target: this.model.target,
      newTab: this.model.newTab,
    };
  }

  public get imageSource(): string {
    return this.model.imagePath ?? '';
  }
}
